import { DropdownItem } from './types';
import { ComponentWithDropdown } from './ComponentWithDropdown';
import { FlexBox } from '@ardoq/layout';
import React, {
  PropsWithChildren,
  ReactNode,
  forwardRef,
  ElementType,
} from 'react';

type NavigationDropdownWrapperProps = PropsWithChildren<{
  navigationOptions: DropdownItem[];
  WrapperComponent?: ElementType;
  isDisabled?: boolean;
}>;

type DropdownTriggerProps = {
  onMenuOpen: () => void;
  children: ReactNode;
  WrapperComponent: ElementType;
  isDisabled: boolean;
};

const DropdownTrigger = forwardRef<HTMLDivElement, DropdownTriggerProps>(
  ({ onMenuOpen, children, WrapperComponent, isDisabled }, ref) => (
    <WrapperComponent
      ref={ref}
      onClick={!isDisabled ? onMenuOpen : undefined}
      role="button"
      tabIndex={0}
      style={{ cursor: 'pointer' }}
      aria-disabled={isDisabled}
    >
      {children}
    </WrapperComponent>
  )
);
DropdownTrigger.displayName = 'DropdownTrigger';

export const NavigationDropdown = ({
  navigationOptions,
  children,
  WrapperComponent = FlexBox,
  isDisabled = false,
}: NavigationDropdownWrapperProps) => {
  return (
    <ComponentWithDropdown
      options={navigationOptions}
      Component={props => (
        <DropdownTrigger
          {...props}
          WrapperComponent={WrapperComponent}
          isDisabled={isDisabled}
        >
          {children}
        </DropdownTrigger>
      )}
    />
  );
};
